import { h, RefObject } from "preact";

import Loading from "./Loading";
import classname from "../../foundation/utils/classname";

import styles from "./OrganizationSummary.module.css";

interface Props {
    class?: string;
    imageSrc?: string;
    title: string;
    subInfo: string;
    dashboardLink?: string;
    rightContent?: JSX.Element;
    baseRef: RefObject<HTMLDivElement>;
}

function OrganizationSummary({
    class: cssClass,
    imageSrc,
    title,
    subInfo,
    dashboardLink,
    rightContent,
    baseRef
}: Props) {
    const organizationLogo = (
        <div class={classname(styles.logo, { [styles.placeholder]: !imageSrc })}>
            {imageSrc && <img src={imageSrc} width="64" height="64"/>}
        </div>
    );

    return (
        <div class={classname(styles.organizationSummary, cssClass)} ref={baseRef}>
            <div class={styles.summary}>
                {dashboardLink ? (
                    <a href={dashboardLink} target="_blank">{organizationLogo}</a>
                ) : organizationLogo}
                <div>
                    {dashboardLink ? <a href={dashboardLink} target="_blank" class={styles.organizationTitle}>{title}</a> : <div class={styles.organizationTitle}>{title}</div>}
                    <div class={styles.organizationSubInfo}>{subInfo}</div>
                </div>
            </div>
            {rightContent}
        </div>
    );
}

OrganizationSummary.Loading = Loading;

export default OrganizationSummary;
